import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: 'App',
  data: function data() {
    return {
      renewAuthTokenInterval: null
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this = this;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return this.renewAuthToken();
          case 3:
            _context2.next = 8;
            break;
          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](0);
            console.trace(_context2.t0);
          case 8:
            this.renewAuthTokenInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.renewAuthToken();
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), 60 * 1000 * 60);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[0, 5]]);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  destroyed: function destroyed() {
    if (this.renewAuthTokenInterval) {
      clearInterval(this.renewAuthTokenInterval);
      this.renewAuthTokenInterval = null;
    }
  },
  methods: {
    renewAuthToken: function () {
      var _renewAuthToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.$store.getters.token) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return this.$store.dispatch('user/renewAuthToken');
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function renewAuthToken() {
        return _renewAuthToken.apply(this, arguments);
      }
      return renewAuthToken;
    }()
  }
};